import { useContext, useEffect, useRef, useState } from 'react';
import Title from '../custom/Title';
import { TCustomerFields } from '../../Models/Inbound';
import { TransactionContext } from '../../contexts/TransactionContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import styled from 'styled-components';
import useService from '../../hooks/useService';
import { createCustomer, getCityStateFromMts, getCustomer, updateCustomer } from '../../services/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';
import { ICustomerAddress, ICustomerBasic, ICustomerSummary } from '../../Models/Customer';
import { PATHS, PURITY_VERIFICATION_CHARGE_OPTIONS, RGPStockModal, STATES, TRANSACTION_TYPES } from '../../utils/constant';
import { genId } from '../../utils/helpers';
import { TCreateCustomerParam } from '../../services/Customer/types';
import DynamicForm, { TDynamicFieldProps, TField, useDynamicForm } from '../forms/DynamicFormNew';
import { Button, FormHelperText, Tooltip, Box, IconButton, Typography } from '@mui/material';
import { createUserAuthLetter, deleteUserAuthLetter, getUserAuthLetter, initiateTransaction } from '../../services/Transactions';
import HighlightsCard from '../$HighlightsCard';
import CustomerPanUpload from '../_CustomerSetup/CustomerPanUpload'
import Modal from '../Modals'
import { GridCloseIcon } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const Divider = styled.div`
    border: 1px solid #EBEBEC;
`

type TCustomerInfo = ICustomerBasic & ICustomerAddress
type TCreateCustomerInfo = ICustomerBasic & { addresses: ICustomerAddress[] }



export let MTSStates : any = [  ]
export let MTScity : any = [  ]
export const USER_CONFIG: TField<TCustomerFields & { chargesDetails: string, GMSCharges: string, userDocuments: string }>[] = [

    
    {
        fieldName: 'mobileNumber',
        isVisible: true,
        fieldType: 'text',
        label: 'Mobile Number',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'fullName',
        isVisible: true,
        fieldType: 'text',
        label: 'Customer Name',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'emailAddress',
        isVisible: true,
        fieldType: 'text',
        label: 'Email',
        width: 'calc(33% - 20px)',
    },
    {
        fieldName: 'mainAccountNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Main Account Number',
        width: 'calc(33% - 20px)',
    },
    {
        fieldName: 'gender',
        isVisible: true,
        fieldType: 'select',
        label: 'Gender',
        width: 'calc(33% - 20px)',
        options: [{ value: "male", label: 'Male' }, { value: "female", label: 'Female' }, { value: 'other', label: 'Other' }],
    },
    {
        fieldName: 'nationality',
        isVisible: true,
        fieldType: 'select',
        label: 'Nationality',
        width: 'calc(33% - 20px)',
        options: [{ value: "indian", label: 'Indian' }],
        initialValue: 'indian'
    },
    {
        fieldName: 'gstin',
        isVisible: true,
        fieldType: 'text',
        label: 'GSTIN',
        width: 'calc(33% - 20px)',
    },
    {
        fieldName: 'line1',
        isVisible: true,
        fieldType: 'text',
        label: 'Address Line 1',
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        }
    },
    {
        fieldName: 'line2',
        isVisible: true,
        fieldType: 'text',
        label: 'Address Line 2',
        width: 'calc(33% - 20px)',
    },
    {
        fieldName: 'city',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'City',
        options: MTScity,
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        },
        freeSolo : true
    },
    {
        fieldName: 'state',
        isVisible: true,
        fieldType: 'autocomplete',
        label: 'State',
        fullWidth: false,
        options: MTSStates,
        width: 'calc(33% - 20px)',
        validation: {
            required: true
        },
        freeSolo : false
    },
    {
        fieldName: 'country',
        isVisible: true,
        fieldType: 'text',
        label: 'Country',
        width: 'calc(33% - 20px)',
        defaultValue : "India",
        value : "India",
    },
    {
        fieldName: 'zip',
        isVisible: true,
        fieldType: 'text',
        label: 'Zipcode',
        width: 'calc(33% - 20px)',
        validation: {
            required: true,
            minLength:6,
            maxLength:6
        }
    },
    {
        fieldName: 'userType',
        isVisible: true,
        fieldType: 'select',
        label: 'User Type',
        fullWidth: false,
        options: [{ value: "regular", label: 'Regular' }, { value: "employee", label: 'Employee' }, { value: "F&F", label: 'Friends & Family' }],
        validation:{
            required:true
        },
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'employeeCode',
        isVisible: false,
        fieldType: 'text',
        label: 'Employee Code',
        fullWidth: false,
        width: 'calc(33% - 20px)'
    },
    {
        fieldName: 'purityVerificationCharges',
        isVisible: false,
        fieldType: 'select',
        label: 'Purity Verification Charges',
        width: 'calc(33% - 20px)',
        options: PURITY_VERIFICATION_CHARGE_OPTIONS
    },
    // {
    //     fieldName: 'chargesDetails',
    //     isVisible: true,
    //     fieldType: 'comment',
    //     label: 'Charge Details',
    //     fullWidth: true,
    // },
    // {
    //     fieldName: 'GMSCharges',
    //     isVisible: true,
    //     fieldType: 'comment',
    //     label: 'GMS Charges (Rs PER GR) 17.50',
    //     fullWidth: true,
    // },
    {
        fieldName: 'userDocuments',
        isVisible: true,
        fieldType: 'custom',
        label: 'Image',
        width: '100%',
        fullWidth: true,
        validation: {
            required: false
        }
    }
]

type TCustomerForm = TCustomerFields & {
  chargesDetails: string;
  GMSCharges: string;
  userDocuments: string;
};

const UploadDocument = (props: TDynamicFieldProps<TCustomerForm>) => {
  const { execute, store } = useService();
  const { transactionsStore, notificationStore } = store;
  const { transactionInfo, userAuthFiles } = transactionsStore;
  const { customerConfig } = useContext(CustomerContext)
  const { notify } = notificationStore;
  const { error } = props;

  const [hoveredFile, setHoveredFile] = useState('');
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  // ---------- file → base64 ----------
  const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });

  // ---------- upload ----------
  const uploadFile = async (file: File) => {
    const base64 = await fileToBase64(file);

    const { data, error } = await execute(() =>
      createUserAuthLetter({
        dgCustomerRefNo: customerConfig.dgCustomerRefNo!,
        authFile: base64,
        transactionType: transactionInfo.transactionType,
      })
    );

    if (!error && data) notify('File Uploaded.');
  };

  // ---------- delete ----------
  const deleteFile = async (id: string) => {
    const { data, error } = await execute(() =>
      deleteUserAuthLetter({
        id,
        dgCustomerRefNo: customerConfig.dgCustomerRefNo!,
        transactionType: transactionInfo.transactionType,
      })
    );

    if (!error && data) notify('File Deleted.');
  };

  // ---------- download ----------
  const downloadFile = (fileUrl: string, idx: number) => {
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.download = `${transactionInfo.globalTransactionNumber!}-${idx + 1}`;
    anchor.click();
    anchor.remove();
  };

  // ---------- input change ----------
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files?.length) return;

    for (const file of Array.from(files)) {
      await uploadFile(file);
    }

    e.target.value = '';
  };

  const isPdf = (url: string) => /\.pdf($|\?)/i.test(url);

  return (
    <>
      <div>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => fileInputRef.current?.click()}
        >
          {userAuthFiles.length > 0
            ? 'Add More'
            : 'Upload File'}
        </Button>

        <input
          ref={fileInputRef}
          type="file"
          hidden
          multiple
          accept="image/*,.pdf"
          onChange={handleFileChange}
        />

        {/* ---------- grid ---------- */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
            gap: '10px', 
            marginTop: '15px',
            justifyContent: 'flex-start',
          }}
        >
          {userAuthFiles.map((elem, idx) => (
            <div
                key={elem.id}
                style={{
                    marginRight: "15px",
                    position: "relative",
                    width: 100,
                }}
                >
                {/* Delete Button */}
                <IconButton
                    size="small"
                    onClick={() => deleteFile(elem.id)}
                    sx={{
                    position: "absolute",
                    top: -8,
                    right: -8,
                    bgcolor: "white",
                    boxShadow: 1,
                    zIndex: 10,
                    "&:hover": { bgcolor: "#f5f5f5" },
                    }}
                >
                    <GridCloseIcon fontSize="small" />
                </IconButton>

                {/* Preview Box */}
                <Box
                    sx={{
                    width: 100,
                    height: 100,
                    border: "1px solid #ddd",
                    borderRadius: 1,
                    overflow: "hidden",
                    bgcolor: "#fafafa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    cursor: "pointer",
                    "&:hover .download-btn": {
                        opacity: 1,
                    },
                    }}
                >
                    {/* Preview */}
                    {isPdf(elem.authFile) ? (
                        <Box
                            sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "#fff4f4",
                            border: "1px solid #f5c2c2",
                            borderRadius: 1,
                            }}
                        >
                            <PictureAsPdfIcon
                                sx={{ fontSize: 42, mb: 0.5 }}
                                color="error"
                            />
                            <Typography
                                variant="caption"
                                fontWeight={600}
                                color="error"
                            >
                                PDF
                            </Typography>
                        </Box>
                        ) : (
                        <img
                            src={elem.authFile}
                            alt="preview"
                            style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            }}
                        />
                    )}
                    {/* Download */}
                    <Tooltip title="Download">
                    <IconButton
                        className="download-btn"
                        size="small"
                        onClick={() =>
                        downloadFile(elem.authFile, idx)
                        }
                        sx={{
                        position: "absolute",
                        bottom: 4,
                        right: 4,
                        bgcolor: "white",
                        opacity: 0,
                        transition: "0.2s",
                        boxShadow: 1,
                        "&:hover": { bgcolor: "#f5f5f5" },
                        }}
                    >
                        <DownloadIcon fontSize="small" />
                    </IconButton>
                    </Tooltip>
                </Box>
            </div>
          ))}
        </div>
      </div>

      {error && <FormHelperText error>{error}</FormHelperText>}
    </>
  );
};


function CustomerDetails(props: { closeCustomerDetails: () => any, customerRefNo?: string, goNext: (id: string) => any, parentCustomerRef?: string, type?: string, path?: string }) {
    const { closeCustomerDetails, customerRefNo, goNext, parentCustomerRef, type, path } = props
    const { customerConfig, customerAddresses, setCustomerConfig, setCustomerAddresses, mobileVerificationId } = useContext(CustomerContext)
    const { notify } = useContext(NotificationContext)

    const { transactionInfo, setTransactionInfo } = useContext(TransactionContext)
    const { execute } = useService()
    const { registerForm, setField, setFormData, setFormConfig, formData, } = useDynamicForm({
        formConfig: customerRefNo ? USER_CONFIG.map(field => ({ ...field, disabled: true })) : USER_CONFIG

    })
    const [loading, setLoading] = useState(true);
    const [isFieldEdit, setIsFieldEdit] = useState<boolean>(false)
    // const config = () => USER_CONFIG.map(field => ({ ...field, value: {...customerConfig, ...customerAddresses[0]}[field.fieldName  as keyof TCustomerInfo] }))
    const [showPanForm, setShowPanForm] = useState<boolean>(false)
    const { dgCustomerRefNo } = customerConfig

    useEffect(()=>{
        let statesMaster='CNIND'
        getstatecity(statesMaster);
     
        if(customerConfig.isCorporate === 'Y'){
            setFormConfig(prev => {
                return [...prev.map(config => {
                    
                    let conditionToDisable = config.fieldName === 'country' ||
                                            config.fieldName === "city" || 
                                            config.fieldName === "state" || 
                                            config.fieldName === "line1" || 
                                            config.fieldName === "line2" ||
                                            config.fieldName === "zip"
                    if (conditionToDisable) {
                        return { ...config, isVisible : false, validation : { required: false} }
                    } else return config
                })]
            })
        }
    },[])
    // customerConfig

    const createTransaction = async (customerId: string, purityVerificationCharges:number) => {
        switch(transactionInfo.transactionType){
            case TRANSACTION_TYPES.BUY_SELL:
                if(!customerConfig.buysellMetalReturnPercentage) {
                    return notify('Buysell Metal Return Percentage is not declared for customer', 'error')
                }
                if(!customerConfig.buysellPgmMetalReturnPercentage) {
                    return notify('Buysell PGM Metal Return Percentage is not declared for customer', 'error')
                }
                if(!customerConfig.refiningCharges) {
                    return notify('Refining Charge is not declared for customer', 'error')
                }
                break
            case TRANSACTION_TYPES.JOB_WORK:
                // if(!customerConfig.jobworkMetalReturnPercentage) {
                //     return notify('Jobwork Metal Return Percentage is not declared for customer', 'error')
                // }
                // if(!customerConfig.jobworkPgmMetalReturnPercentage) {
                //     return notify('Jobwork PGM Metal Return Percentage is not declared for customer', 'error')
                // }
                if(!customerConfig.refiningCharges) {
                    return notify('Refining Charge is not declared for customer', 'error')
                }
                break
            case TRANSACTION_TYPES.PURITY_TESTING:
                if(!purityVerificationCharges) {
                    return notify('Purity Verification Charge is not declared for customer', 'error')
                }
                break
        }
        const { error, data } = await execute(() => initiateTransaction({
            currency: transactionInfo.currency,
            customerId,
            pvcCenterId: transactionInfo.pvcCenterId!,
            transactionType: transactionInfo.transactionType,
            weightUOM: transactionInfo.weightUOM,
            parentCustomerId: parentCustomerRef
        }))
        let customerPurchaseHistory : any;
        if(data){
            customerPurchaseHistory = {
                employee_total_gold_weight : data.customerPurchaseHistory?.employee_total_gold_weight,
                employee_total_silver_weight : data.customerPurchaseHistory?.employee_total_silver_weight,
                friends_and_family_total_gold_weight: data.customerPurchaseHistory?.friends_and_family_total_gold_weight,
                friends_and_family_total_silver_weight: data.customerPurchaseHistory?.friends_and_family_total_silver_weight
            }
        }
        if (error === null) {
            setTransactionInfo(prev => ({
                ...prev,
                customerId,
                globalTransactionNumber: data?.transaction.globalTransactionNumber,
                customerPurchaseHistory
            }))
            goNext(data?.transaction.globalTransactionNumber!)
        }
    }
    const updateCustomers = (data: any) => {
        return execute(() => updateCustomer(data))
    }
    const createNewCustomer = async(data:any)=>{

        let stateCodeFromMaster : any = await  getStateCodeFromMaster(data.state)

        const customer: TCreateCustomerParam = {
            addresses: [{
                name: data.fullName,
                mobileNumber: data.mobileNumber,
                line1: data.line1,
                line2: data.line2,
                city: data.city,
                state: data.state,
                // stateCode: STATES.filter(state => state.value === data.state)[0].code,
                stateCode: stateCodeFromMaster,
                country: "India",
                zip: data.zip,
                isActive: true,
                type: 'B',
                id: genId()
            }],
            displayName: data.fullName,
            fullName: data.fullName,
            mainAccountNo: data.mainAccountNo,
            gender: data.gender,
            gstin: data.gstin,
            userType: data.userType,
            employeeCode: data.employeeCode,
            accountStatus: 'active',
            emailStatus: 'I',
            isCorporate: 'N',
            kycStatus: 'I',
            maritalStatus: '',
            mobileNumber: data.mobileNumber,
            nationality: data.nationality,
            platform: '',
            profession: '',
            sendPromotions: false,
            type: 'regular',
            emailAddress: data.emailAddress,
            mobileVerificationId,
            partnerId: 'mpipl',
            purityVerificationCharges: data.purityVerificationCharges,
            walletBalance: data.walletBalance
        }
        // setCustomerConfig(customer as ICustomerBasic)
        const { error, data: response } = await execute(() => createCustomer(customer as TCreateCustomerParam))
        if (error === null) {
            console.log(response?.customerRefNo!,'customerRefNo_____')
            await execute(() => getCustomer({ customerRefNo: response?.customerRefNo! }))
            if ( response?.kycStatus === "I" && (path === PATHS.BUY_BACK || path === PATHS.GMS)){
                    setFormData({ ...customerAddresses[0], ...customerConfig } as any)
                    notify('User details saved!')
            }else{
                createTransaction(response?.customerRefNo!, data.purityVerificationCharges!)
                setFormData({ ...customerAddresses[0], ...customerConfig } as any)
                notify('User details saved!')
                closeCustomerDetails()
            }
            if(!customerConfig.customerRefNo)await execute(() => getCustomer({ customerRefNo: response?.customerRefNo! }))

        }
    }
    const updateAndSubmitHandler = async (data: TCustomerFields) => {

        if(Object.keys(customerConfig).length === 1){
            createNewCustomer(data)
            return 
        }
        let stateCodeFromMaster : any = await  getStateCodeFromMaster(data.state)


        const updatedCustomerData = {
            customer: {
                addresses: [{
                    id: customerAddresses[0]?.id,
                    name: data.fullName,
                    mobileNumber: customerConfig.mobileNumber,
                    line1: data.line1,
                    line2: data.line2,
                    city: data.city,
                    state: data.state,
                    // stateCode: STATES.filter(state => state.value === data.state)[0]?.code,
                    stateCode :stateCodeFromMaster,
                    country: "India",
                    zip: data.zip,
                    isActive: true,
                    type: 'B',
                    customerRefNo: customerConfig.customerRefNo
                }],

                displayName: data.fullName,
                fullName: data.fullName,
                mainAccountNo: data.mainAccountNo,
                gender: data.gender,
                gstin: data.gstin,
                maritalStatus: '',
                nationality: data.nationality,
                emailAddress: data.emailAddress,
                sendPromotions: customerConfig.sendPromotions,
                isCorporate: customerConfig.isCorporate,
                mobileVerificationId,
                purityVerificationCharges: data.purityVerificationCharges,
                userType: data.userType,
                employeeCode: data.employeeCode,
                mobileNumber: data.mobileNumber
            },
            customerRefNo: data.customerRefNo!,
            updateReqFromTransaction:true

            
        }
        console.log(updatedCustomerData,customerAddresses,'update_customer')

        const result = await updateCustomers(updatedCustomerData)
        console.log("update customer result", result,result.error?.reason)
        if(result.data!= null) {
          let respose =  await execute(() => getCustomer({ customerRefNo: customerRefNo! }))
            closeCustomerDetails()
            notify('User details updated!')
            if (customerRefNo ){
                await execute(() => getCustomer({ customerRefNo: customerRefNo! }))
                return type !== RGPStockModal && createTransaction(customerRefNo, data.purityVerificationCharges!)}
        }else return notify(`${result.error?.reason}` || 'Cannot update the customer, Try again!',"error")

    }
 
    const submitHandler = async (data: TCustomerFields) => {
        console.log("customer res is the ---", customerRefNo)

        if(type === RGPStockModal) {
            setFormData({ ...customerAddresses[0], ...customerConfig } as any)
            closeCustomerDetails()
        } else {
            if((path === PATHS.BUY_BACK || path === PATHS.GMS) && customerConfig?.kycStatus === "I") {
                setShowPanForm(true)
                return
            }

            if (customerRefNo) return createTransaction(customerRefNo, customerConfig.purityVerificationCharges!)
            createNewCustomer(data)
        }
    }

    
  async function getStateCodeFromMaster(stateorcity : any){
    let stateCode = true ;
    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode}))
    console.log(data,"statecodefrommaster")
    //@ts-ignore
   if(data != null) return data[0]?.state_code
 }

    const goBack = () => {
        setCustomerAddresses([])
        setCustomerConfig({} as ICustomerBasic)
        closeCustomerDetails()
    }

    const fetchCustomer = async() => {
        setLoading(true);
        if (customerRefNo)  await execute(() =>  getCustomer({ customerRefNo }))
        setLoading(false);
    }

    const fetchUserAuthFiles = async () => {
        const { data, error } = await execute(() => getUserAuthLetter({ dgCustomerRefNo: dgCustomerRefNo }));
    }

    const hasFetched = useRef(false);
    useEffect(() => {
        if (!dgCustomerRefNo || hasFetched.current) return;

        hasFetched.current = true;
        fetchUserAuthFiles()
    }, [dgCustomerRefNo])

    useEffect(() => {
        fetchCustomer();
    }, [])

    useEffect(() => {
        setFormData(customerConfig as any);
    },[customerConfig]);

    useEffect(() => {
        let showEmployee= formData.userType === 'employee' || formData.userType === 'F&F'
        setField('employeeCode', {isVisible:showEmployee , validation:{ required:showEmployee }})
    }, [formData.userType])

    useEffect(() => {
        // alert('customer_Address')
        if(customerAddresses?.length > 0)
            setFormData({ ...customerAddresses[0], ...customerConfig } as any)
    }, [ customerAddresses])


    // useEffect(() => {
    //     // alert('customer_Address_!')
    //     if(formData && formData?.state !=''){
    //         if(/[a-z]/.test(formData.state) || /[a-z]/.test(formData.city)){
    //             formData.state = ""
    //             formData.city = ""
    //             formData.country =""
    //         }
    //        } 
    // }, [formData])
    




  
    

    // const RenderDynamicForm = () => {
    //     return !loading ? <DynamicForm {...registerForm()} onSubmit={submitHandler} submitText={customerRefNo ? 'Confirm' : 'Create'} onCancel={goBack} cancelText='Back' /> : <></>
    // }
    console.log(customerConfig,transactionInfo,customerAddresses,'customer_config')
    const getHightlights = () => {
        let availableBalance = Number(customerConfig.walletBalance) || 0
        const highlights = [
            { label: 'Job work PGM metal return percentage', value: customerConfig.jobworkPgmMetalReturnPercentage },
            { label: 'Job work metal return percentage', value: customerConfig.jobworkMetalReturnPercentage },
            { label: 'Buy sell PGM metal return percentage', value: customerConfig.buysellPgmMetalReturnPercentage },
            { label: 'Buy sell metal return percentage', value: customerConfig.buysellMetalReturnPercentage },
            { label: 'Purity verification charges', value: customerConfig.purityVerificationCharges },
            { label: 'Available Balance' , value : Number(availableBalance.toFixed(2)) }
        ]
     

        //@ts-ignore
        if(customerConfig.mtsIsTDSApplicable==null) highlights.push({label : 'TCS/TDS Applicability',value : 'Not Declared'})
        //@ts-ignore
        if(customerConfig.mtsIsTDSApplicable=="0") highlights.push({label : 'TCS/TDS Applicability',value : 'TCS Applicable'})
        //@ts-ignore
        if(customerConfig.mtsIsTDSApplicable=="1") highlights.push({label : 'TCS/TDS Applicability',value : 'TDS Applicable'})
        //@ts-ignore
        if(customerConfig.refiningCharges == null)  highlights.push({label : 'Refining Charges',value : ''})
        else highlights.push({label : 'Refining Charges',value : customerConfig.refiningCharges})


        // getstatecity();

        return highlights
    }


    useEffect(() => {
        if (isFieldEdit) {
            setFormConfig(prev => {
                return [...prev.map(field => {
                    if (field.fieldName === 'mobileNumber' || field.fieldName === 'country') {
                        field.disabled = true
                    }
                   else if (field.fieldName === 'fullName' && customerConfig?.fullName) {
                        field.disabled = true
                    }  
                    else field.disabled = false
                    return field
                })]
            })
            // setFormData({ ...customerConfig } as any)
        } else {
            setFormData({ ...customerConfig } as any)
            setFormConfig(prev => {
                return [...prev.map(field => {
                    field.disabled = true
                    return field
                })]
            })
        }

    }, [isFieldEdit])
    useEffect(() => {
        if (transactionInfo.transactionType === TRANSACTION_TYPES.PURITY_TESTING) {
            setFormConfig(prev => {
                return [...prev.map(field => {
                    if (field.fieldName === 'purityVerificationCharges') {
                        field.isVisible = true
                        field.validation = {required:true}
                    }
                    return field
                })]
            })
        } 
    }, [])

    useEffect(() => {
        setFormConfig(prev => {
                return [...prev.map(field => {
                    if(customerConfig.isCorporate === 'Y' && field.fieldName === 'userDocuments') {
                        field.RenderField = UploadDocument;
                    }
                    return field
                })]
            })
    }, [customerConfig.isCorporate])

    useEffect(()=>{
        MTScity = []
        if(formData.state)getCityFromMaster(formData.state)  
        else formData.state = "" 

             
    },[formData.state])

async function getCityFromMaster(stateorcity : any ){
  let  stateCode = false
    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity,stateCode}))
     if(data!){
        // MTScity =[]
        let updated_cities = [];
        //@ts-ignore
        for(let i = 0 ; i < data.length ; i++ ){
            //@ts-ignore
            let cities = {value:data[i].domain_description, label:data[i].domain_description, code: i+1} 
            updated_cities.push(cities)
        }
        setField('city', {options:updated_cities })

     }
   
}



{/* <USER_CONFIG cities={cities} /> */}

async function getstatecity(stateorcity : any){
  let  stateCode = false
    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode}))
     if(data! && MTSStates.length=== 0){
        //@ts-ignore
        for(let i = 0 ; i < data.length ; i++ ){
            //@ts-ignore
            let state = {value:data[i].domain_description, label:data[i].domain_description, code: "25"} 
            MTSStates.push(state)
        }
     }
 }
 useEffect(() => {

    if(customerAddresses && customerAddresses.length == 1 ){
        if(formData && customerAddresses[0]?.state != formData.state)
            getCityFromMaster(customerAddresses[0].state)
    }

 }, [customerAddresses])

    useEffect(() => {
        if(path !== PATHS.BUY_BACK && path !== PATHS.GMS) return
        if (customerConfig?.kycStatus === "I") {
            setShowPanForm(true)
            return
        }
    }, [customerConfig])
    
    return (
        <div>
            <div style={{ borderBottom: '1px solid #f1f1f1', color: '#7f7d76' }}>
                <Title style={{ textAlign: 'left', margin: '10px' }}>Customer Details</Title>
            </div>
            <HighlightsCard fields={getHightlights()} />
            <Divider />
            <div style={{ padding: '20px 10px' }}>
                {!loading ? <DynamicForm {...registerForm()} onSubmit={isFieldEdit ? updateAndSubmitHandler : submitHandler} submitText={customerRefNo ? (isFieldEdit ? 'Save and Continue' : 'Confirm') : 'Create'} onCancel={goBack} cancelText='Back' /> : <></>}
            </div>
            <Button disabled={customerConfig.isCorporate === 'Y'} style={{ marginLeft: '10px' }} variant='outlined' onClick={() => setIsFieldEdit(prev => !prev)}>{isFieldEdit ? 'Cancel editing' : 'Edit Customer Detail'}</Button>
            <Modal open={Boolean(showPanForm)} title={'Upload PAN'} onClose={()=> setShowPanForm(false)} >
                <CustomerPanUpload customerDetail={customerConfig as ICustomerSummary} modalClose={() => setShowPanForm(false)} onSuccess={fetchCustomer} />
            </Modal>
        </div>
    )
}

export default CustomerDetails